'use strict';

module.exports = [
    function () {

        return {
            restrict: 'E',
            scope: {
                heading: '@mdHeading',
                icon: '@?mdIcon',
                svgIcon: '@?mdSvgIcon',
                arrow: '@?mdArrow',
                rmSref: '=rmSref',
                visible: '=?mdIsOpen'

            },
            replace: true,
            transclude: true,
            template: `
            <div class="rm-side-menu-content" layout="column">
                <md-button class="rm-side-menu-toggle" ng-if="heading" ng-click="changeState();" ng-class="{ 'md-active': visible }">
                    <div layout="row">
                        <md-icon ng-if="svgIcon" md-svg-icon="svgIcon"></md-icon>
                        <md-icon ng-if="icon">{{ icon }}</md-icon>
                        <span flex>{{ heading }}</span>
                        <md-icon ng-if="arrow">keyboard_arrow_down</md-icon>
                    </div>
                </md-button>
                <div class="rm-side-menu-wrapper" ng-class="{ 'md-active': visible, 'rm-side-menu-wrapper-icons':  icon }" layout="column" ng-transclude></div>
            </div>`,
            controller: ['$scope', '$state', sideMenuContentCtrl],
            controllerAs: 'ctrl',
            link: function (scope) {
                //Not used
            }
        };


        function sideMenuContentCtrl( scope, $state ) {

            scope.changeState = ( ) => {

                if(scope.rmSref) {
                    $state.go(scope.rmSref);
                } else {
                    scope.visible = !scope.visible;
                }
            };
        }
    }
];

